import api from "./api";
const endpoint = "/volontariat/AssociationMembre";
export const AssociationMembreService = {
  async find_one(input) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: input,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_by_id(id) {
    try {
      const result = await api.get(endpoint + "/find_by_id", {
        params: { id_membre_par_lot: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async liste(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
